module.exports = __webpack_public_path__ + "static/media/logo.9ee9a5b8.png";